'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateFromElement = require('./stateFromElement');

Object.defineProperty(exports, 'stateFromElement', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateFromElement).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-import-element/lib/main.js
// module id = 545
// module chunks = 1 2